import { useEvent } from "../../../context/EventContext";

//  * The Location component renders the location details of the selected event. If the
//  * selected event does not have any location details, it renders a message saying
//  * "No Location Details found.".

const Location = () => {
  const { selectedEvent } = useEvent();

  // The selected event could be null if the user has not clicked on any event.
  const locationDetailsArray =
    selectedEvent && selectedEvent[1] ? selectedEvent[1] : [];

  return (
    <div className="location-section-details">
      {/* Render the "No Location Details found." message if the selected event does not have any location details. */}
      {locationDetailsArray.length === 0 && (
        <h1 style={{ paddingLeft: "300px" }}>No Location Details found.</h1>
      )}
      {/* Map over the location details array and render the details for each type of location. */}
      {locationDetailsArray.map((locationDetails, index) => (
        <div key={index}>
          {/* Render the details for a hall. */}
          {locationDetails.space_type === "hall" && (
            <div className="hall-details">
              <p>Hall Details</p>
              <p>
                Name: <span>{locationDetails.space_name}</span>
              </p>
              <p>
                Code: <span>{locationDetails.space_code}</span>
              </p>
              <p>
                Capacity: <span>{locationDetails.space_capacity} people</span>
              </p>
              <p>
                Floor Address: <span>{locationDetails.space_address}</span>
              </p>
            </div>
          )}
          {/* Render the details for a meeting room. */}
          {locationDetails.space_type === "meeting room" && (
            <div className="meeting-details">
              <p>Meeting Room Details</p>
              <p>
                Room Name: <span>{locationDetails.space_name}</span>
              </p>
              <p>
                Room Code: <span>{locationDetails.space_code}</span>
              </p>
              <p>
                Capacity: <span>{locationDetails.space_capacity} people</span>
              </p>
              <p>
                Floor Address: Floor Address:{" "}
                <span>{locationDetails.space_address}</span>
              </p>
            </div>
          )}
          {/* Render the details for a open space. */}
          {locationDetails.space_type === "open space" && (
            <div className="openspace-details">
              <p>Open Space Details</p>
              <p>
                Name: <span>{locationDetails.space_name}</span>
              </p>
              <p>
                Code: <span>{locationDetails.space_code}</span>
              </p>
              <p>
                Capacity: <span>{locationDetails.space_capacity}</span>
              </p>
              <p>
                Floor Address: <span>{locationDetails.space_address}</span>
              </p>
            </div>
          )}
          {/* Render the details for a auditorium. */}
          {locationDetails.space_type === "auditorium" && (
            <div className="auditorium-details">
              <p>Auditorium Details</p>
              <p>
                Name: <span>{locationDetails.space_name}</span>
              </p>
              <p>
                Code: <span>{locationDetails.space_code}</span>
              </p>
              <p>
                Capacity: <span>{locationDetails.space_capacity} people</span>
              </p>
              <p>
                Floor Address: <span>{locationDetails.space_address}</span>
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Location;
